import React, { useState } from 'react';

import Localization from '../Localization';
import Modal from '../Modal';
import About from './About';
import FAQ from './FAQ';
import languages from '../Localization/languages';

import './styles.scss';
import hamburger from '../images/hamburger.svg';
import close from '../images/close.svg';
import logo from '../images/BU-GDPC-logo-inverted.png';
import twitter from '../images/twitter.png';
import facebook from '../images/facebook.png';

const text = encodeURIComponent('Explore the China’s Global Power Database via @gdp_center: ')
const links = {
  twitter: `https://twitter.com/intent/tweet?text=${text}&url=`,
  facebook: 'https://www.facebook.com/sharer.php?u=',
};

function share(site) {
  const url = encodeURIComponent(document.location);
  const link = links[site];
  window.open(`${link}${url}`);
}

export default function Header(props) {
  const [showAbout, setShowAbout] = useState(false);
  const [showFaq, setShowFaq] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isNarrow = props.width <= 640;

  function faqToAbout(e) {
    e.preventDefault();
    setShowFaq(false);
    setShowAbout(true);
  }

  return (
    <div className='Header'>
      <div className='logo'>
        <a href='https://www.bu.edu/gdp/' target='_blank' rel='noopener noreferrer'>
          <img src={logo} alt='Boston University' />
        </a>
      </div>
      <div className={`menu ${menuOpen ? 'open' : ''}`}>
        <div className='menuClose' onClick={() => setMenuOpen(false)}>
          <img src={close} alt='x' />
        </div>
        <div className='section infoGroup'>
          <div className='info' onClick={() => setShowAbout(hide => !hide)}>
            {Localization.get('About / Data Download')}
          </div>
          <div className='info' onClick={() => setShowFaq(hide => !hide)}>
            {Localization.get('FAQ')}
          </div>
        </div>
        <div className='section languageSelector'>
          <div className='label'>
            {`${Localization.get('Language')}${isNarrow ? '' : ':'}`}
          </div>
          <div className='group'>
            {languages.map(lang => (
              <div
                key={lang.locale}
                className={`language ${lang.locale === props.language ? 'selected' : ''}`}
                onClick={() => props.updateLanguage(lang.locale)}
              >
                {lang.label === 'EN' && isNarrow ? 'English' : lang.label}
              </div>
            ))}
          </div>
        </div>
        <div className='section share'>
          <div className='label'>
            {Localization.get('Share')}
          </div>
          <div className='group'>
            <div className='social' onClick={() => share('twitter')}>
              <img src={twitter} alt='twitter' />
            </div>
            <div className='social' onClick={() => share('facebook')}>
              <img src={facebook} alt='facebook' />
            </div>
          </div>
        </div>
      </div>
      <div className='menuToggle' onClick={() => setMenuOpen(open => !open)}>
        <img src={hamburger} alt='menu' />
      </div>
      <Modal type='about' show={showAbout} setShow={setShowAbout} scrollTarget={props.scrollTarget}>
        <About setShow={setShowAbout} />
      </Modal>
      <Modal type='faq' show={showFaq} setShow={setShowFaq} scrollTarget={props.scrollTarget}>
        <FAQ setShow={setShowFaq} showAbout={faqToAbout} />
      </Modal>
    </div>
  );
}